import { Box, Button, Grid, TextField, Typography, FormControl, FormControlLabel, RadioGroup, Radio } from '@mui/material'
import FormSubmissionSuccessDialog from '../../../components/FormSubmissionSuccessDialog/FormSubmissionSuccessDialog';
import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik';
import * as Yup from "yup";
import './TenantCnicUpdation.scss';
import CircularProgress from '@mui/material/CircularProgress';
import { cfpBaseUrl, mnrURL } from '../../../network/urls';
import Backdrop from '@mui/material/Backdrop';
import Error from '../../../components/error/error';
import { dBillAPI, handleFileUpload, isImage, isPdf } from '../../../services/Functions';
import { getMNRToken } from '../../../network/APIs/APIs';
import { documentExtensions, portalName } from '../../../utils/PortalName';
import pdfIcon from "../../../images/pdfIcon.png";
import CloseIcon from '@mui/icons-material/Close';
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { useSelector } from "react-redux";
import StepProgressBar from '../../../components/StepProgressBarForm/StepProgressBar';

const initialValues = {
    iv_consumer_id: "",
    iv_old_name: "",
    iv_old_cnic: "",
    iv_old_phone: "",
    iv_old_email: "",
    iv_new_name: "",
    iv_new_cnic: "",
    iv_new_phone_no: "",
    iv_new_email: "",
    iv_reference_number: '',
    iv_applicant_cnic_document_front: null,
    iv_applicant_cnic_document_back: null,
    iv_bill_image: null,
    iv_rent_agreement: null,
    iv_property_proof: null,
    iv_affidavite: null,
};
const CNICUpdation = () => {
    const [name, setName] = useState('')
    const [referenceNumber, setReferenceNumber] = useState('')
    const [phoneNo, setPhoneNo] = useState('')
    const [cnicNo, setCnicNo] = useState('')
    const [email, setEmail] = useState('')
    const [error, setError] = useState('');
    const [searchBy, setSearchBy] = useState('consumerId')
    const [tenantCNICUpdatePopUp, setTenantCNICUpdatePopUp] = useState(false)
    const [tcnicStatusBarArray, setTcnicStatusBarArray] = useState([
        { title1: 'APPLICATION', title2: 'DETAIL', status: 0 },
        { title1: `APPLICANT'S`, title2: 'CNIC', status: 0 },
        { title1: 'PROPERTY', title2: 'PROOF', status: 0 },
        { title1: 'RENTAL', title2: 'AGREEMENT', status: 0 },
        { title1: 'BILL', title2: 'IMAGE', status: 0 },
        { title1: 'AFFIDAVIT', title2: 'DOC', status: 0 },
    ]);
    const {token} = useSelector((state) => state.auth);

    const setTcnicStepStatus = (index, isComplete) => {
        setTcnicStatusBarArray((prevArray) => {
            const updatedArray = [...prevArray];
            updatedArray[index] = {
                ...updatedArray[index],
                status: isComplete ? 1 : 0,
            };
            return updatedArray;
        });
    };

    const resetTcnicStatusBar = () => {
        setTcnicStatusBarArray((prevArray) =>
            prevArray.map((step) => ({ ...step, status: 0 })),
        );
    };
    const errorCloses = () => {
        setError('')
    }

    // const [email, setEmail] = useState('')
    const [viewBackdrop, setViewBackdrop] = useState(false);

    const SearchBy = (event) => {
        values.iv_search_by = event.target.value;
        setSearchBy(event.target.value);
        setName()
        setPhoneNo()
        setEmail()
        setCnicNo()
        values.iv_consumer_id = ""
        values.iv_reference_number = ""
        values.iv_old_name = ""
        values.iv_old_cnic = ""
        values.iv_old_phone = ""
        values.iv_old_email = ""
        values.iv_new_name = ""
        values.iv_new_cnic = ""
        values.iv_new_phone_no = ""
        values.iv_new_email = ""
        setApplicantCnicDocumentFront()
        setApplicantCnicDocumentBack()
        setPropertyProof()
        setRentAgreement()
        setBillImage()
        setAffidavite()
        setApplicantCnicDocumentFrontThumbnail()
        setApplicantCnicDocumentBackThumbnail()
        setPropertyProofThumbnail()
        setRentAgreementThumbnail()
        setBillImageThumbnail()
        setAffidaviteThumbnail()
        setApplicantCnicDocumentFrontError()
        setApplicantCnicDocumentBackError()
        setPropertyProofError()
        setRentAgreementError()
        setBillImageError()
        setAffidaviteError()
        resetTcnicStatusBar();
    };

    const [applicantCnicDocumentFront, setApplicantCnicDocumentFront] = useState("");
    const [applicantCnicDocumentBack, setApplicantCnicDocumentBack] = useState("");
    const [propertyProof, setPropertyProof] = useState("");
    const [rentAgreement, setRentAgreement] = useState("");
    const [affidavite, setAffidavite] = useState("");
    const [billImage, setBillImage] = useState("");

    const [applicantCnicDocumentFrontError, setApplicantCnicDocumentFrontError] = useState("");
    const [applicantCnicDocumentBackError, setApplicantCnicDocumentBackError] = useState("");
    const [propertyProofError, setPropertyProofError] = useState("");
    const [rentAgreementError, setRentAgreementError] = useState("");
    const [affidaviteError, setAffidaviteError] = useState("");
    const [billImageError, setBillImageError] = useState("");

    const [applicantCnicDocumentFrontThumbnail, setApplicantCnicDocumentFrontThumbnail] = useState("");
    const [applicantCnicDocumentBackThumbnail, setApplicantCnicDocumentBackThumbnail] = useState("");
    const [propertyProofThumbnail, setPropertyProofThumbnail] = useState("");
    const [rentAgreementThumbnail, setRentAgreementThumbnail] = useState("");
    const [affidaviteThumbnail, setAffidaviteThumbnail] = useState("");
    const [billImageThumbnail, setBillImageThumbnail] = useState("");

    const ApplicantCnicDocumentFront = (event) => {
        if (event.target.files) {
            const newFileName = 'copyOfApplicantCNICFront.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, handleChange, setApplicantCnicDocumentFront, setApplicantCnicDocumentFrontError, setApplicantCnicDocumentFrontThumbnail, newFileName);
        }
    };

    const ApplicantCnicDocumentBack = (event) => {
        if (event.target.files) {
            const newFileName = 'copyOfApplicantCNICBack.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, handleChange, setApplicantCnicDocumentBack, setApplicantCnicDocumentBackError, setApplicantCnicDocumentBackThumbnail, newFileName);
        }
    };

    const PropertyProof = (event) => {
        if (event.target.files) {
            const newFileName = 'propertyProof.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, handleChange, setPropertyProof, setPropertyProofError, setPropertyProofThumbnail, newFileName);
        }
    };

    const RentAgreement = (event) => {
        if (event.target.files) {
            const newFileName = 'rentAgreement.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, handleChange, setRentAgreement, setRentAgreementError, setRentAgreementThumbnail, newFileName);
        }
    };

    const Affidavite = (event) => {
        if (event.target.files) {
            const newFileName = 'affidavite.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, handleChange, setAffidavite, setAffidaviteError, setAffidaviteThumbnail, newFileName);
        }
    };

    const BillImage = (event) => {
        if (event.target.files) {
            const newFileName = 'billImage.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, handleChange, setBillImage, setBillImageError, setBillImageThumbnail, newFileName);
        }
    };

    const { values, errors, touched, handleChange, handleBlur, handleSubmit } = useFormik({

        initialValues,
        validationSchema: Yup.object({
            iv_reference_number: Yup.string().when('iv_search_by', {
                is: () => searchBy === 'referenceNo',
                then: Yup.string().min(14, 'Reference No. must be 14 digits.').max(14, 'Reference No. must be 14 digits.').required("Enter reference number."),
                otherwise: Yup.string().optional()
            }),
            iv_consumer_id: Yup.string().when('iv_search_by', {
                is: () => searchBy === 'consumerId',
                then: Yup.string().min(10, 'Customer ID. must be 10 digits.').max(10, 'Customer ID. must be 10 digits.').required("Enter consumer Id."),
                otherwise: Yup.string().optional()
            }),
            iv_old_name: Yup.string().optional(),
            iv_old_cnic: Yup.mixed().optional(),
            iv_old_phone: Yup.mixed().optional(),
            iv_old_email: Yup.mixed().optional(),
            iv_new_name: Yup.string().min(3, 'New name must be at least 3 characters.').max(30, 'New name must not be more than 30 characters.').required("Enter new Name."),
            //Newemail:Yup.string().email().required("This field is must"),
            iv_new_phone_no: Yup.string().max(11, "Please enter 11 digit phone number.")
                .min(11, "Please enter 11 digit phone number.")
                .required("Enter new mobile number.")
                .matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Phone number as 03001234567"),
            iv_new_cnic: Yup.string().min(13, "Please enter 13 digit CNIC.")
                .max(13, "Please enter 13 digit CNIC.")
                .required("Enter new CNIC number.")
                .matches(/^[0-9]+$/, "Enter CNIC number as 3520212345678."),
            iv_new_email: Yup.string()
                .email("Enter email as 'john@gmail.com'.")
                .required("Enter new email."),
            iv_applicant_cnic_document_front: Yup.mixed().required("Please upload CNIC Front image in jpg, jpeg, png or pdf format."),
            // iv_applicant_cnic_document_back: Yup.mixed().required("Please upload CNIC Back image in jpg, jpeg, png or pdf format."),
            iv_bill_image: Yup.mixed().required("Please upload Bill image in jpg, jpeg, png or pdf format."),
            iv_rent_agreement: Yup.mixed().required("Please upload Rent Agreement image in jpg, jpeg, png or pdf format."),
            iv_property_proof: Yup.mixed().required("Please upload Property Proof image in jpg, jpeg, png or pdf format."),
            iv_affidavite: Yup.mixed().required("Please upload Affidavite image in jpg, jpeg, png or pdf format."),
        }),
        onSubmit: async (values, { resetForm }) => {
            setViewBackdrop(true);

            const token = await getMNRToken();
            console.log(token, 'printing token')
            if (token) {
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

                const urlencoded = new URLSearchParams();
                urlencoded.append("ref_no", referenceNumber);
                urlencoded.append("owner_name", values.iv_old_name);
                urlencoded.append("owner_cnic", values.iv_old_cnic);
                urlencoded.append("owner_mobile", values.iv_old_phone);
                urlencoded.append("occup_name", values.iv_new_name);
                urlencoded.append("occup_cnic", values.iv_new_cnic);
                urlencoded.append("occup_mobile", values.iv_new_phone_no);
                urlencoded.append("occup_image", applicantCnicDocumentFrontThumbnail.split(',')[1]);
                urlencoded.append("bill_image", billImageThumbnail.split(',')[1]);
                urlencoded.append("rent_agreement", rentAgreementThumbnail.split(',')[1]);
                urlencoded.append("property_proof", propertyProofThumbnail.split(',')[1]);
                urlencoded.append("affidavit", affidaviteThumbnail.split(',')[1]);
                urlencoded.append("source", portalName);
                urlencoded.append("key", token);

                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: urlencoded,
                    redirect: "follow"
                };

                await fetch(mnrURL + "save_cnicapi.php", requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status) {
                            setViewBackdrop(false)
                            setTenantCNICUpdatePopUp(true)
                        }
                        else {
                            setViewBackdrop(false)
                        }
                    }).catch(error => {
                        setViewBackdrop(false)
                    });
                resetForm();
                setName();
                setCnicNo();
                setPhoneNo();
                setEmail();
                setApplicantCnicDocumentFront()
                setApplicantCnicDocumentBack()
                setPropertyProof()
                setRentAgreement()
                setBillImage()
                setAffidavite()
                setApplicantCnicDocumentFrontThumbnail()
                setApplicantCnicDocumentBackThumbnail()
                setPropertyProofThumbnail()
                setRentAgreementThumbnail()
                setBillImageThumbnail()
                setAffidaviteThumbnail()
                setApplicantCnicDocumentFrontError()
                setApplicantCnicDocumentBackError()
                setPropertyProofError()
                setRentAgreementError()
                setBillImageError()
                setAffidaviteError()
                resetTcnicStatusBar();
            }
            setViewBackdrop(false)
        }
    })

    // Calling Billing API to fetch near by details
    useEffect(() => {
        if (values.iv_consumer_id.length === 10) {
            referenceApi();
        } else {
            setError('')
            setName()
            setEmail()
            setCnicNo()
            setPhoneNo()
            values.iv_new_cnic = ''
            values.iv_new_name = ''
            values.iv_new_email = ''
            values.iv_new_phone_no = ''
            values.iv_old_name = ""
            values.iv_old_cnic = ""
            values.iv_old_phone = ""
            values.iv_old_email = ""
            values.iv_reference_number = ''
            setApplicantCnicDocumentFront()
            setApplicantCnicDocumentBack()
            setPropertyProof()
            setRentAgreement()
            setBillImage()
            setAffidavite()
            setApplicantCnicDocumentFrontThumbnail()
            setApplicantCnicDocumentBackThumbnail()
            setPropertyProofThumbnail()
            setRentAgreementThumbnail()
            setBillImageThumbnail()
            setAffidaviteThumbnail()
            setApplicantCnicDocumentFrontError()
            setApplicantCnicDocumentBackError()
            setPropertyProofError()
            setRentAgreementError()
            setBillImageError()
            setAffidaviteError()
        }
    }, [values.iv_consumer_id])

    useEffect(() => {
        if (values.iv_reference_number.length === 14) {
            referenceApi();
        } else {
            setError('')
            setName()
            setEmail()
            setCnicNo()
            setPhoneNo()
            values.iv_new_cnic = ''
            values.iv_consumer_id = ''
            values.iv_new_name = ''
            values.iv_new_email = ''
            values.iv_old_name = ""
            values.iv_old_cnic = ""
            values.iv_old_phone = ""
            values.iv_old_email = ""
            values.iv_new_phone_no = ''
            setApplicantCnicDocumentFront()
            setApplicantCnicDocumentBack()
            setPropertyProof()
            setRentAgreement()
            setBillImage()
            setAffidavite()
            setApplicantCnicDocumentFrontThumbnail()
            setApplicantCnicDocumentBackThumbnail()
            setPropertyProofThumbnail()
            setRentAgreementThumbnail()
            setBillImageThumbnail()
            setAffidaviteThumbnail()
            setApplicantCnicDocumentFrontError()
            setApplicantCnicDocumentBackError()
            setPropertyProofError()
            setRentAgreementError()
            setBillImageError()
            setAffidaviteError()
        }
    }, [values.iv_reference_number])

    useEffect(() => {
        const hasValidSearch =
            (searchBy === 'consumerId' && values.iv_consumer_id.length === 10) ||
            (searchBy === 'referenceNo' && values.iv_reference_number.length === 14);
        const hasLoadedCurrentInfo = Boolean(
            String(values.iv_old_name || '').trim() &&
            String(values.iv_old_cnic || '').trim(),
        );
        const hasNewApplicantDetail =
            String(values.iv_new_name || '').trim().length >= 3 &&
            values.iv_new_cnic.length === 13 &&
            values.iv_new_phone_no.length === 11 &&
            String(values.iv_new_email || '').trim() &&
            !errors.iv_new_email;

        setTcnicStepStatus(
            0,
            hasValidSearch && hasLoadedCurrentInfo && hasNewApplicantDetail,
        );
    }, [
        searchBy,
        values.iv_consumer_id,
        values.iv_reference_number,
        values.iv_old_name,
        values.iv_old_cnic,
        values.iv_new_name,
        values.iv_new_cnic,
        values.iv_new_phone_no,
        values.iv_new_email,
        errors.iv_new_email,
    ]);

    useEffect(() => {
        setTcnicStepStatus(1, Boolean(applicantCnicDocumentFront));
    }, [applicantCnicDocumentFront]);

    useEffect(() => {
        setTcnicStepStatus(2, Boolean(propertyProof));
    }, [propertyProof]);

    useEffect(() => {
        setTcnicStepStatus(3, Boolean(rentAgreement));
    }, [rentAgreement]);

    useEffect(() => {
        setTcnicStepStatus(4, Boolean(billImage));
    }, [billImage]);

    useEffect(() => {
        setTcnicStepStatus(5, Boolean(affidavite));
    }, [affidavite]);

    const referenceApi = async () => {
        if (searchBy === 'consumerId') {
            setViewBackdrop(true)
            if (!values.iv_consumer_id) return;
            let apiResponse = await dBillAPI(token, values.iv_consumer_id)
            if (apiResponse.status) {
                const basicInfo = apiResponse.basicInfo
                setReferenceNumber(basicInfo.refNo.replace(/ /g, "").slice(0, 14))
                values.iv_old_name = basicInfo.consumerName
                values.iv_old_cnic = basicInfo.occupant_cnic
                values.iv_old_phone = basicInfo.consumerContactNo
                values.iv_old_email = basicInfo.consumerEmail
            } else {
                console.log('Reference No. not found!')
            }
            setViewBackdrop(false)
        }
        if (searchBy === 'referenceNo') {
            setViewBackdrop(true)
            if (!values.iv_reference_number) return;
            let apiResponse = await dBillAPI(token, values.iv_reference_number)
            if (apiResponse.status) {
                const basicInfo = apiResponse.basicInfo
                setReferenceNumber(basicInfo.refNo.replace(/ /g, "").slice(0, 14))
                values.iv_old_name = basicInfo.consumerName
                values.iv_old_cnic = basicInfo.occupant_cnic
                values.iv_old_phone = basicInfo.consumerContactNo
                values.iv_old_email = basicInfo.consumerEmail
            } else {
                console.log('Reference No. not found!')
            }
            setViewBackdrop(false)
        }
    };

    const submitEnabled =
        (values.iv_consumer_id.length === 10 || values.iv_reference_number.length === 14) &&
        values.iv_new_name !== '' &&
        values.iv_new_cnic.length === 13 &&
        values.iv_new_phone_no.length === 11;

    const renderUploadButton = ({
        file,
        thumbnail,
        onClear,
        onChange,
        inputId,
        inputName,
        clientError,
        altText,
        buttonLabel = 'Upload',
    }) => (
        <div className="upload-wrap">
            {file ? (
                <Button
                    component="label"
                    className="upload-preview"
                    startIcon={
                        <CloseIcon
                            className="button-with-image"
                            onClick={onClear}
                        />
                    }
                >
                    {thumbnail && isImage(file) ? (
                        <div className="btn-div">
                            <img src={thumbnail} alt={altText} width="80" />
                        </div>
                    ) : isPdf(file) ? (
                        <div className="btn-div">
                            <img src={pdfIcon} alt="PDF" width="80" />
                        </div>
                    ) : (
                        <span>Other file type</span>
                    )}
                </Button>
            ) : (
                <>
                    <Button
                        variant="outlined"
                        component="label"
                        startIcon={<FileUploadOutlinedIcon />}
                        className="btn"
                    >
                        {buttonLabel}
                        <input
                            hidden
                            accept={documentExtensions}
                            id={inputId}
                            name={inputName}
                            type="file"
                            onChange={onChange}
                        />
                    </Button>
                    {clientError ? <Box className="documentError">{clientError}</Box> : null}
                </>
            )}
        </div>
    );

    const renderDocumentUpload = ({
        label,
        file,
        thumbnail,
        onClear,
        onChange,
        inputId,
        inputName,
        validationError,
        clientError,
        altText,
        buttonLabel = 'Upload',
    }    ) => (
        <Grid item xs={12} sm={6} md={4} lg={4} className="tc-doc-col">
            <div className="tc-doc-col-head">
            <label className="fieldLabel doc-grid-label">{label}</label>
            {validationError ? <Box className="documentError">{validationError}</Box> : null}
            </div>
            <div className="doc-grid-uploads">
                {renderUploadButton({
                    file,
                    thumbnail,
                    onClear,
                    onChange,
                    inputId,
                    inputName,
                    clientError,
                    altText,
                    buttonLabel,
                })}
            </div>
        </Grid>
    );

    const renderCnicDocumentUpload = ({
        label,
        frontFile,
        frontThumbnail,
        onClearFront,
        onChangeFront,
        frontInputId,
        frontInputName,
        frontValidationError,
        frontClientError,
        frontAltText,
        backFile,
        backThumbnail,
        onClearBack,
        onChangeBack,
        backInputId,
        backInputName,
        backValidationError,
        backClientError,
        backAltText,
    }    ) => (
        <Grid item xs={12} sm={6} md={4} lg={4} className="tc-doc-col">
            <div className="tc-doc-col-head">
            <label className="fieldLabel doc-grid-label">{label}</label>
            {frontValidationError ? (
                <Box className="documentError">{frontValidationError}</Box>
            ) : null}
            {backValidationError ? (
                <Box className="documentError">{backValidationError}</Box>
            ) : null}
            </div>
            <div className="doc-grid-uploads cnic-upload-pair">
                {renderUploadButton({
                    file: frontFile,
                    thumbnail: frontThumbnail,
                    onClear: onClearFront,
                    onChange: onChangeFront,
                    inputId: frontInputId,
                    inputName: frontInputName,
                    clientError: frontClientError,
                    altText: frontAltText,
                    buttonLabel: 'Front',
                })}
                {renderUploadButton({
                    file: backFile,
                    thumbnail: backThumbnail,
                    onClear: onClearBack,
                    onChange: onChangeBack,
                    inputId: backInputId,
                    inputName: backInputName,
                    clientError: backClientError,
                    altText: backAltText,
                    buttonLabel: 'Back',
                })}
            </div>
        </Grid>
    );

    return (
        <>
            <Grid container className="tenant-cnic-page" sx={{ width: '100%', maxWidth: '100%' }}>
                <Box className="tenant-cnic-container" sx={{ width: '100%', maxWidth: '100%' }}>
                    <h3 className="heading">Update Tenant CNIC</h3>
                    <div className="tc-stepper-wrap">
                        <StepProgressBar
                            array={tcnicStatusBarArray}
                            pageName="Tenant CNIC Form"
                        />
                    </div>
                    <form className="tc-form">
                        <div className="section-card section-card--accent">
                            <div className="section-title">Connection Details</div>
                            <p className="section-subtitle">
                                Search by Customer ID or Reference No. to load current tenant information.
                            </p>
                            <div className="db-search-fields">
                                <div className="field-wrap field-wrap--search-by db-search-fields__item">
                                    <label className="fieldLabel">Search By</label>
                                    <div className="db-search-fields__control">
                                        <FormControl
                                            margin="none"
                                            className="form-control form-control--search-by"
                                        >
                                            <RadioGroup
                                                className="radio-group"
                                                row
                                                name="iv_search_by"
                                                value={searchBy}
                                                onChange={SearchBy}
                                            >
                                                <FormControlLabel
                                                    value="consumerId"
                                                    className="form-control-label"
                                                    control={<Radio size="small" />}
                                                    label="Customer ID"
                                                    labelPlacement="end"
                                                />
                                                <FormControlLabel
                                                    value="referenceNo"
                                                    className="form-control-label"
                                                    control={<Radio size="small" />}
                                                    label="Reference No."
                                                    labelPlacement="end"
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                    </div>
                                </div>

                                {searchBy === 'consumerId' && (
                                    <div className="field-wrap db-search-fields__item db-search-fields__item--input">
                                        <label className="fieldLabel" htmlFor="iv_consumer_id">
                                            Customer ID
                                        </label>
                                        <div className="db-search-fields__control">
                                            <TextField
                                                margin="none"
                                                required
                                                type="text"
                                                autoComplete="off"
                                                name="iv_consumer_id"
                                                value={values.iv_consumer_id}
                                                onChange={handleChange}
                                                inputProps={{ maxLength: 10, inputMode: 'numeric' }}
                                                onBlur={handleBlur}
                                                id="iv_consumer_id"
                                                placeholder="10-digit customer ID"
                                                className="textInputField"
                                                fullWidth
                                            />
                                        </div>
                                        <Box className="from-Error">
                                            {errors.iv_consumer_id && touched.iv_consumer_id
                                                ? errors.iv_consumer_id
                                                : null}
                                        </Box>
                                    </div>
                                )}

                                {searchBy === 'referenceNo' && (
                                    <div className="field-wrap db-search-fields__item db-search-fields__item--input">
                                        <label className="fieldLabel" htmlFor="iv_reference_number">
                                            Reference No.
                                        </label>
                                        <div className="db-search-fields__control">
                                            <TextField
                                                margin="none"
                                                required
                                                type="text"
                                                autoComplete="off"
                                                name="iv_reference_number"
                                                value={values.iv_reference_number}
                                                onChange={handleChange}
                                                inputProps={{ maxLength: 14, inputMode: 'numeric' }}
                                                onBlur={handleBlur}
                                                id="iv_reference_number"
                                                placeholder="14-digit reference number"
                                                className="textInputField"
                                                fullWidth
                                            />
                                        </div>
                                        <Box className="from-Error">
                                            {errors.iv_reference_number && touched.iv_reference_number
                                                ? errors.iv_reference_number
                                                : null}
                                        </Box>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="section-card section-card--current">
                            <div className="section-title">Current Information</div>
                            <Grid container spacing={1}>
                            <Grid item xs={12} sm={6} md={3}>
                                <div className="field-wrap">
                                <label className="fieldLabel">Name</label>
                                <TextField
                                    disabled
                                    fullWidth
                                    name="iv_old_name"
                                    value={values.iv_old_name}
                                    id="iv_old_name"
                                    className="textInputField1"
                                />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <div className="field-wrap">
                                <label className="fieldLabel">CNIC</label>
                                <TextField
                                    disabled
                                    fullWidth
                                    name="iv_old_cnic"
                                    value={values.iv_old_cnic}
                                    inputProps={{ maxLength: 13 }}
                                    id="iv_old_cnic"
                                    className="textInputField1"
                                />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <div className="field-wrap">
                                <label className="fieldLabel">Phone No.</label>
                                <TextField
                                    disabled
                                    fullWidth
                                    name="iv_old_phone"
                                    inputProps={{ maxLength: 11 }}
                                    value={values.iv_old_phone}
                                    id="iv_old_phone"
                                    className="textInputField1"
                                />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <div className="field-wrap">
                                <label className="fieldLabel">Email</label>
                                <TextField
                                    disabled
                                    fullWidth
                                    name="iv_old_email"
                                    value={values.iv_old_email}
                                    id="iv_old_email"
                                    className="textInputField1"
                                />
                                </div>
                            </Grid>
                            </Grid>
                        </div>

                        <div className="section-card section-card--new">
                            <div className="section-title">New Information</div>
                            <Grid container spacing={1}>
                            <Grid item xs={12} sm={6} md={3}>
                                <div className="field-wrap">
                                    <label className="fieldLabel" htmlFor="newName">Name</label>
                                    <TextField
                                        required
                                        fullWidth
                                        name="iv_new_name"
                                        value={values.iv_new_name}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        id="newName"
                                        className="textInputField"
                                    />
                                    <Box className="from-Error">
                                        {errors.iv_new_name && touched.iv_new_name ? errors.iv_new_name : null}
                                    </Box>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <div className="field-wrap">
                                    <label className="fieldLabel" htmlFor="newCnicNo">CNIC</label>
                                    <TextField
                                        required
                                        fullWidth
                                        name="iv_new_cnic"
                                        inputProps={{ maxLength: 13 }}
                                        value={values.iv_new_cnic}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        id="newCnicNo"
                                        className="textInputField"
                                    />
                                    <Box className="from-Error">
                                        {errors.iv_new_cnic && touched.iv_new_cnic ? errors.iv_new_cnic : null}
                                    </Box>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <div className="field-wrap">
                                    <label className="fieldLabel" htmlFor="newNumber">Phone No.</label>
                                    <TextField
                                        required
                                        fullWidth
                                        name="iv_new_phone_no"
                                        inputProps={{ maxLength: 11 }}
                                        value={values.iv_new_phone_no}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        id="newNumber"
                                        className="textInputField"
                                    />
                                    <Box className="from-Error">
                                        {errors.iv_new_phone_no && touched.iv_new_phone_no
                                            ? errors.iv_new_phone_no
                                            : null}
                                    </Box>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <div className="field-wrap">
                                    <label className="fieldLabel" htmlFor="iv_new_email">Email</label>
                                    <TextField
                                        required
                                        fullWidth
                                        name="iv_new_email"
                                        value={values.iv_new_email}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        id="iv_new_email"
                                        className="textInputField"
                                    />
                                    <Box className="from-Error">
                                        {errors.iv_new_email && touched.iv_new_email ? errors.iv_new_email : null}
                                    </Box>
                                </div>
                            </Grid>
                            </Grid>
                        </div>

                        <div className="section-card section-card--docs">
                            <div className="section-title">Required Documents</div>
                            <Grid container spacing={2} className="documentsContainer documents-grid">
                                {renderCnicDocumentUpload({
                                    label: "1- Applicant's CNIC",
                                    frontFile: applicantCnicDocumentFront,
                                    frontThumbnail: applicantCnicDocumentFrontThumbnail,
                                    onClearFront: () => setApplicantCnicDocumentFront(''),
                                    onChangeFront: ApplicantCnicDocumentFront,
                                    frontInputId: 'iv_applicant_cnic_document_front',
                                    frontInputName: 'iv_applicant_cnic_document_front',
                                    frontValidationError:
                                        errors.iv_applicant_cnic_document_front &&
                                        touched.iv_applicant_cnic_document_front
                                            ? errors.iv_applicant_cnic_document_front
                                            : null,
                                    frontClientError:
                                        applicantCnicDocumentFront === ''
                                            ? applicantCnicDocumentFrontError
                                            : null,
                                    frontAltText: 'Applicant CNIC Front',
                                    backFile: applicantCnicDocumentBack,
                                    backThumbnail: applicantCnicDocumentBackThumbnail,
                                    onClearBack: () => setApplicantCnicDocumentBack(''),
                                    onChangeBack: ApplicantCnicDocumentBack,
                                    backInputId: 'iv_applicant_cnic_document_back',
                                    backInputName: 'iv_applicant_cnic_document_back',
                                    backValidationError:
                                        errors.iv_applicant_cnic_document_back &&
                                        touched.iv_applicant_cnic_document_back
                                            ? errors.iv_applicant_cnic_document_back
                                            : null,
                                    backClientError:
                                        applicantCnicDocumentBack === ''
                                            ? applicantCnicDocumentBackError
                                            : null,
                                    backAltText: 'Applicant CNIC Back',
                                })}
                                {renderDocumentUpload({
                                    label: '2- Property Proof',
                                    file: propertyProof,
                                    thumbnail: propertyProofThumbnail,
                                    onClear: () => setPropertyProof(''),
                                    onChange: PropertyProof,
                                    inputId: 'iv_property_proof',
                                    inputName: 'iv_property_proof',
                                    validationError:
                                        errors.iv_property_proof && touched.iv_property_proof
                                            ? errors.iv_property_proof
                                            : null,
                                    clientError:
                                        propertyProof === '' ? propertyProofError : null,
                                    altText: 'Property Documents',
                                })}
                                {renderDocumentUpload({
                                    label: '3- Rental Agreement',
                                    file: rentAgreement,
                                    thumbnail: rentAgreementThumbnail,
                                    onClear: () => setRentAgreement(''),
                                    onChange: RentAgreement,
                                    inputId: 'iv_rent_agreement',
                                    inputName: 'iv_rent_agreement',
                                    validationError:
                                        errors.iv_rent_agreement && touched.iv_rent_agreement
                                            ? errors.iv_rent_agreement
                                            : null,
                                    clientError: rentAgreement === '' ? rentAgreementError : null,
                                    altText: 'Rent Agreement',
                                })}
                                {renderDocumentUpload({
                                    label: '4- Bill Image',
                                    file: billImage,
                                    thumbnail: billImageThumbnail,
                                    onClear: () => setBillImage(''),
                                    onChange: BillImage,
                                    inputId: 'iv_bill_image',
                                    inputName: 'iv_bill_image',
                                    validationError:
                                        errors.iv_bill_image && touched.iv_bill_image
                                            ? errors.iv_bill_image
                                            : null,
                                    clientError: billImage === '' ? billImageError : null,
                                    altText: 'Bill',
                                })}
                                {renderDocumentUpload({
                                    label: '5- Affidavite',
                                    file: affidavite,
                                    thumbnail: affidaviteThumbnail,
                                    onClear: () => setAffidavite(''),
                                    onChange: Affidavite,
                                    inputId: 'iv_affidavite',
                                    inputName: 'iv_affidavite',
                                    validationError:
                                        errors.iv_affidavite && touched.iv_affidavite
                                            ? errors.iv_affidavite
                                            : null,
                                    clientError: affidavite === '' ? affidaviteError : null,
                                    altText: 'Affidavite',
                                })}
                            </Grid>
                        </div>

                        {error ? (
                            <Error
                                error={error}
                                onClose={() => errorCloses()}
                                backgroundColor="#FFC0CB"
                                textColor="#bb0303"
                                iconColor="#bb0303"
                            />
                        ) : null}

                        <div className="submit-area">
                            <Button
                                className="submit-btn"
                                variant="contained"
                                type="submit"
                                onClick={handleSubmit}
                                disabled={!submitEnabled}
                            >
                                Submit
                            </Button>
                        </div>
                    </form>
                </Box>
            </Grid>

            <FormSubmissionSuccessDialog
                open={tenantCNICUpdatePopUp}
                onClose={() => setTenantCNICUpdatePopUp(false)}
                title="Data updated"
                message={`Tenant Data updated successfully for Reference No.: ${referenceNumber}.`}
            />

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop >
        </>
    );
}
export default CNICUpdation;
